var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import { Grid } from "react-bootstrap";
import Card from "@irati/ui/src/Layout/Card";
import { H2 } from "@irati/ui/src/Headings";
import StepIndicator from "@irati/ui/src/StepIndicator";
import { FormattedMessage } from "@irati/utils/lang";
import { minWidthMedia } from "@irati/ui/src/global/media";
import doctorCareAnywhere from "../../images/doctorCareAnywhere.svg";
var STEPS_COUNT = 3;
var StyledGrid = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["padding-top: 30px;"], ["padding-top: 30px;"])));
var StyledCard = styled(Card)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 30px;\n  min-height: 130px;\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 30px;\n  min-height: 130px;\n  ",
    "\n"])), minWidthMedia.tablet(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-direction: row;\n    min-height: auto;\n  "], ["\n    flex-direction: row;\n    min-height: auto;\n  "]))));
var Logo = styled.img(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: block;\n  margin: 30px auto 0;\n  width: 125px;\n"], ["\n  display: block;\n  margin: 30px auto 0;\n  width: 125px;\n"])));
var NoPaddingBottomCard = styled(Card)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  overflow: hidden;\n  padding-bottom: 20px;\n  ", "\n"], ["\n  overflow: hidden;\n  padding-bottom: 20px;\n  ",
    "\n"])), minWidthMedia.tablet(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding-bottom: 0;\n  "], ["\n    padding-bottom: 0;\n  "]))));
var StepPage = /** @class */ (function (_super) {
    __extends(StepPage, _super);
    function StepPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StepPage.prototype.render = function () {
        var _a = this.props, currentStep = _a.currentStep, noPaddingBottom = _a.noPaddingBottom, children = _a.children;
        var MainContentCard = noPaddingBottom ? NoPaddingBottomCard : Card;
        return (React.createElement(StyledGrid, null,
            React.createElement(StyledCard, null,
                React.createElement(H2, null,
                    React.createElement(FormattedMessage, { id: "medical.landing.steps.header" })),
                React.createElement(StepIndicator, { stepsCount: STEPS_COUNT, currentStep: currentStep })),
            React.createElement(MainContentCard, null, children),
            React.createElement(Logo, { src: doctorCareAnywhere })));
    };
    return StepPage;
}(PureComponent));
export default StepPage;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
